module.exports = __webpack_public_path__ + "assets/9fa98deee6b233dd5b929e06cdea543f.jpg";